import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageview } from '@helsenorge/framework-utils/adobe-analytics';
const useTrackPageView = (enabled = true) => {
    const location = useLocation();
    const previousPathname = useRef();
    useEffect(() => {
        if (enabled && previousPathname.current !== location.pathname) {
            trackPageview();
            previousPathname.current = location.pathname;
        }
    }, [location, enabled]);
};
export default useTrackPageView;
